import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { ABOUT } from "@/constants/testIds";

const points = [
  "Former Division 1 Basketball Coach",
  "Former NBA Player Consultant",
  "Highly connected through college & professional ranks",
  "Guides each family through the recruitment process",
];

export default function About() {
  return (
    <section
      id="about"
      data-testid={ABOUT.section}
      className="section-pad relative overflow-hidden bg-[#050B14] min-h-[820px] lg:min-h-[900px]"
    >
      {/* Coach Sean — centered focal watermark (contains the full kneeling pose) */}
      <div className="absolute inset-0 pointer-events-none">
        <img
          src="/brand/coach-sean.png"
          alt=""
          aria-hidden="true"
          className="absolute inset-0 w-full h-full object-contain object-center opacity-[0.65] select-none"
        />
      </div>
      {/* Left-side scrim only — keeps text readable, lets coach dominate the center-right */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#050B14] via-[#050B14]/85 via-25% to-transparent to-55% pointer-events-none" />
      <div className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-[#050B14] to-transparent pointer-events-none" />
      <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-[#050B14] to-transparent pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-8"
        >
          <div className="overline">About BBA</div>
          <div className="gold-divider mt-4 mb-6" />
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05]">
            A premier basketball development program built on{" "}
            <span className="text-[#B8C5D6]">D1 pedigree</span> and pro-level
            insight.
          </h2>
          <p className="mt-6 text-[#A0ABC0] leading-relaxed text-base sm:text-lg max-w-2xl">
            BBA was founded by Sean Bledsoe with a simple focus — maximize
            your strengths and add more skill to your game. We don't just
            drill in isolation. We teach players how to use their skill in
            real game settings — the difference between training and
            translating.
          </p>

          <ul className="mt-8 grid sm:grid-cols-2 gap-4 max-w-2xl">
            {points.map((p) => (
              <li
                key={p}
                className="flex items-start gap-3 text-white/85 text-sm sm:text-base"
              >
                <CheckCircle2
                  size={18}
                  className="text-[#B8C5D6] mt-1 flex-shrink-0"
                />
                <span>{p}</span>
              </li>
            ))}
          </ul>

          <div className="mt-10 border-l-2 border-[#B8C5D6] pl-5 max-w-xl">
            <div className="text-[10px] tracking-[0.28em] uppercase text-[#93A5C0] mb-2">
              Our Mission
            </div>
            <p className="font-display text-lg sm:text-xl text-white leading-snug tracking-tight">
              "Our program cultivates your talent within a system so that
              your talent will look even better."
            </p>
          </div>

          {/* Founder signature — no boxed caption, cleaner */}
          <div className="mt-10 flex items-center gap-4">
            <div className="w-10 h-px bg-[#B8C5D6]" />
            <div>
              <div className="font-display text-xl text-white leading-tight">
                Sean Bledsoe
              </div>
              <div className="text-[10px] tracking-[0.28em] uppercase text-[#93A5C0] mt-1">
                Founder · Program Director
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
